<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Participações' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content class="schedule-content">
  <div class="gradient-extendido"></div>

  <ion-segment [(ngModel)]="eventoTipo" class="btn-select" mode="ios">
    <ion-segment-button value="projeto">
      <ion-label class="header">{{'eventos' | nomenclatura | async}}</ion-label>
    </ion-segment-button>

    <ion-segment-button value="ensino">
      <ion-label class="header">{{'ensinos' | nomenclatura | async}}</ion-label>
    </ion-segment-button>
  </ion-segment>

  <div [ngSwitch]="eventoTipo" *ngIf="loaded">
    <div *ngSwitchCase="'projeto'">
      <div [hidden]="!eventos.projetos.length">
        <div class="header-name">        
          <ion-note>
            <i class="fa-solid fa-users"></i>
          </ion-note>
          <ion-label>{{'Meus ' | translate}} {{'eventos' | nomenclatura | async}}</ion-label>         
        </div>

        <ion-grid>
          <ion-row *ngFor="let p of eventos.projetos" class="border-bottom" (click)="eventoDetalhes(p)">
            <ion-col size="10">
              <ion-list>
                <ion-item>
                  <ion-note class="edit-icon" slot="start">
                    <i class="fa-light fa-ticket icon"></i>
                  </ion-note>

                  <ion-label class="dados-grup">
                    <h1 style="font-size: 15px">{{p.tema}}</h1>
                    <h3>{{ p.dataInicio | dateFormat:"media" }}</h3>
                    <h2>{{p.tipo}}</h2>
                  </ion-label>
                </ion-item>
              </ion-list>
            </ion-col>
            <ion-col size="2" style="display: flex; align-items: center; justify-content: center;">
              <i class="fa-regular fa-chevron-right icon-list"></i>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>

      <div [hidden]="eventos.projetos.length">
        <sem-registro></sem-registro>
      </div>
    </div>

    <div *ngSwitchCase="'ensino'">
      <div [hidden]="!eventos.ensinos.length">
        <div class="header-name">          
          <i class="fa-solid fa-books"></i>
          <ion-label>{{'Meus ' | translate}} {{'ensinos' | nomenclatura | async}}</ion-label>         
        </div>

        <ion-grid>
          <ion-row class="timeline-item" *ngFor="let i of eventos.ensinos;let last = last">
            <ion-col size="1" class="timeline-dot-col">
              <div class="dot"></div>
              <div class="line" *ngIf="!last"></div>
            </ion-col>

            <ion-col size="10">
              <div (click)="ensinoDetalhes(i)" class="ensino">
                <ion-card>
                  <ion-note class="aling-icon">
                    <i class="fa-solid fa-book-open-reader icon-card"></i>
                  </ion-note>
                  <div class="aling">
                    <ion-card-title>{{i.tema}}</ion-card-title>

                    <ion-card-subtitle>
                      <h3>{{ i.dataInicio | dateFormat:"media" }}</h3>
                      <p>{{i.tipo}}</p>
                    </ion-card-subtitle>
                  </div>
                </ion-card>
              </div>
            </ion-col>

            <ion-col size="1" (click)="ensinoDetalhes(i)">
              <ion-icon class="icon-left icon-list" name="arrow-forward-outline"></ion-icon>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>

      <div [hidden]="eventos.ensinos.length">
        <sem-registro></sem-registro>
      </div>
    </div>
  </div>
</ion-content>
